import "./App.css";
import React from "react";
import MainPage from "./components/Pages/MainPage";
function App() {
  return (
    <React.Fragment>
      <MainPage />
    </React.Fragment>
  );
}

export default App;
